import { Buffer } from 'buffer'
import { store } from 'app/store'
import { Classroom } from 'classes/classroom'
import { Classrooms } from 'classes/classrooms'
import { ComponentStaging } from 'present-lesson/component-staging'
import { Dashboard } from 'dashboard/page'
import { ForgotPassword } from 'auth/forgot-password'
import { Layout, LayoutWithoutReturnToDashboard } from 'app/layout'
import { LessonBuilder } from 'lesson-builder/page'
import { Lessons } from 'lesson-library/page'
import { LessonOverviewPage } from 'lesson-overview/page'
import { QuestionResultsPage } from 'question-results/page'
import { Login } from 'auth/login'
import { ResetPassword } from 'auth/reset-password'
import NewPasswordRequired from 'auth/new-password-required'
import { Settings } from 'settings/page'
import { Signup } from 'auth/signup'
import { StudentOverviewPage } from 'student-overview/page'
import { StudentLessonResultsPage } from 'student-lesson-results/page'
import { Success } from 'auth/success'
import { UploadLessons } from 'upload-lessons/page'
import { Verification } from 'auth/verification'
import { EnterCode } from 'auth/enter-code'
import { PresentLessonPage } from 'present-lesson/page'
import { StudentLivePage } from 'student-live/page'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { UpdateBanner } from 'components/update-banner'
import { ErrorBoundary } from 'components/error-boundary'
import { ScrollToTop } from 'components/scroll-to-top'
import { ToastHost } from 'components/toast'
import { installGlobalErrorHandlers } from 'util/error-reporting'
import 'css/common.css'
import 'css/fonts.css'
import 'css/print.css'

window.Buffer = window.Buffer ?? Buffer

// Every uncaught error/rejection becomes visible (M-BIG3); must run before render
installGlobalErrorHandlers()

// Instant redirect: students go to /enter-code, teachers go to /dashboard
const HomeRedirect = () => {
	const isStudent = localStorage.getItem('studentId')
	return <Navigate to={isStudent ? '/enter-code' : '/dashboard'} replace />
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<Provider store={store}>
	<React.StrictMode>
		<BrowserRouter>
			<ScrollToTop />
			<ErrorBoundary label="root">
			<ToastHost />
			<UpdateBanner />
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route path="settings" element={<Settings />} />
					<Route path="lessons" element={<Lessons />} />
					<Route path="upload-lessons" element={<UploadLessons />} />
					<Route path="lesson-builder" element={<LessonBuilder />} />
					<Route path="staging" element={<ComponentStaging />} />
					<Route path='classrooms' element={<Classrooms />} />
					<Route path='classrooms/:classId' element={<Classroom />} />
					<Route path='classrooms/:classId/lessons/:lessonId' element={<LessonOverviewPage />} />
					<Route path='classrooms/:classId/lessons/:lessonId/questions/:questionId' element={<QuestionResultsPage />} />
					<Route path='classrooms/:classId/students/:studentId' element={<StudentOverviewPage />} />
					<Route path='classrooms/:classId/students/:studentId/lessons/:lessonId' element={<StudentLessonResultsPage />} />
				</Route>
				<Route path="/" element={<LayoutWithoutReturnToDashboard />}>
					<Route index element={<HomeRedirect />} />
					<Route path="new-password-required" element={<NewPasswordRequired />} />
					<Route path="dashboard" element={<Dashboard />} />
					<Route path="login" element={<Login />} />
					<Route path="verification" element={<Verification />} />
					<Route path="signup" element={<Signup />} />
					<Route path="success" element={<Success />} />
					<Route path="forgot-password" element={<ForgotPassword />} />
					<Route path="reset-password" element={<ResetPassword />} />
				</Route>
				<Route path="/enter-code" element={<EnterCode />} />
				{/* Live pages get their own boundaries: a render error mid-class
				    must never take down more than the page it happened on */}
				<Route path="/present/:classId/:lessonId" element={<ErrorBoundary label="present-lesson"><PresentLessonPage /></ErrorBoundary>} />
				<Route path="/live/:sessionCode" element={<ErrorBoundary label="student-live"><StudentLivePage /></ErrorBoundary>} />
			</Routes>
			</ErrorBoundary>
		</BrowserRouter>
	</React.StrictMode>
	</Provider>
)
